import React, { Component } from "react";
import { connect } from "react-redux";
import Background from "../../assets/home2.png";
import FlatButton from "material-ui/FlatButton";
import { firebaseApp } from "../../firebase/firebase";
import { signUpUser } from '../auth/auth_actions';

class Onboarding extends Component {
  constructor(props) {
    super(props);
    this.state = {
      slide: 1,
      email: "",
      password: "",
      phone: "",
      title: "",
      details: ""
    };
  }

  componentDidMount() {}

  handleOnChange = key => event => {
    this.setState({
      [key]: event.target.value
    });
  };

  handleContinue = () => {
        this.setState({
            slide: this.state.slide + 1
        });
    };

  validateEmail = (email) => {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  };

   validatePasswordLength = (password) => {
    console.log(password);
    const re = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/;
    return re.test(String(password));
  };

  render() {
    return (
      <div
        style={{
          background: '#009fff',
          background: "-webkit-linear-gradient(to right, #013243, #59abe3)",
          background: 'linear-gradient(to right, #013243, #59abe3)',
          width: window.innerWidth,
          height: window.innerHeight,
          paddingTop: 100
        }}
      >
        {this.renderWhichSlide()}
      </div>
    );
  }

  renderWhichSlide() {
    switch (this.state.slide) {
      case 1:
        return this.renderSlideOne();
      case 2:
        return this.renderSlideTwo();
      case 3:
        return this.renderSlideThree();
      case 4:
        return this.renderSlideFour();
      case 5:
        return this.renderSlideFive();
      case 6:
        return this.renderSlideSix()
      default:
        this.renderSlideOne();
    }
  }

  renderSlideOne() {
    return (
      <div
        style={{
          width: "55%",
          height: "85%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",

          margin: "auto",
          borderRadius: 10
        }}
      >
        <p style={{ color: "white", fontSize: 50, fontWeight: 300 }}>
          <b>Let's get started</b>
        </p>
        <p
          style={{
            color: "white",
            fontSize: 30,
            fontWeight: 300,
            marginBottom: 30
          }}
        >
          What is your email address?
        </p>
        <br />
        <input
          value={this.state.email}
          type="text"
          style={{
            backgroundColor: "transparent",
            width: "50%",
            borderLeft: "none",
            borderRight: "none",
            borderTop: "none",
            borderBottom: "1px solid #ffffff",
            textAlign: "center",
            color: "#ffffff",
            fontSize: 30
          }}
          
          onChange={this.handleOnChange("email")}
        />
        <br />
        <br />
        <FlatButton
          backgroundColor="#90caf9"
          containerElement="label"
          label={"Continue"}
          fullWidth={false}
          labelStyle={{ fontSize: 16 }}
          style={{ margin: 11 }}
          onClick={this.handleContinue}
          disabled={!this.validateEmail(this.state.email)}
        />
      </div>
    );
  }

  renderSlideTwo() {
    return (
      <div
        style={{
          width: "55%",
          height: "85%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          margin: "auto",
          borderRadius: 10
        }}
      >
        <p style={{ color: "white", fontSize: 50, fontWeight: 300 }}>
          <b>Ok now let's create you a password</b>
        </p>
        <p
          style={{
            color: "white",
            fontSize: 30,
            fontWeight: 300,
            marginBottom: 30
          }}
        >
          Safety first! Your password must contain uppercase, lowercase, a number, a special character, and at least be 8 characters long.
        </p>
        <br />
        <input
          value={this.state.password}
          type="password"
          style={{
            backgroundColor: "transparent",
            width: "50%",
            borderLeft: "none",
            borderRight: "none",
            borderTop: "none",
            borderBottom: "1px solid #ffffff",
            textAlign: "center",
            color: "#ffffff",
            fontSize: 30
          }}
                onChange={this.handleOnChange("password")}
        />
        <br />
        <br />
        <FlatButton
          backgroundColor="#90caf9"
          containerElement="label"
          label={"Continue"}
          fullWidth={false}
          labelStyle={{ fontSize: 16 }}
          style={{ margin: 11 }}
          onClick={this.handleContinue}
          disabled={!this.validatePasswordLength(this.state.password)}
        />
      </div>
    );
  }

  renderSlideThree() {
    return (
      <div
        style={{
          width: "55%",
          height: "85%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          margin: "auto",
          borderRadius: 10
        }}
      >
        <p style={{ color: "white", fontSize: 50, fontWeight: 300 }}>
          <b>Alright, what is your phone number?</b>
        </p>
        <p
          style={{
            color: "white",
            fontSize: 30,
            fontWeight: 300,
            marginBottom: 30
          }}
        >
          We want to provide you important updates about your task
        </p>
        <br />
        <input
          value={this.state.phone}
          type="numeric"
          style={{
            backgroundColor: "transparent",
            width: "50%",
            borderLeft: "none",
            borderRight: "none",
            borderTop: "none",
            borderBottom: "1px solid #ffffff",
            textAlign: "center",
            color: "#ffffff",
            fontSize: 30
          }}
                    onChange={this.handleOnChange("phone")}
        />
        <br />
        <br />
        <FlatButton
          backgroundColor="#90caf9"
          containerElement="label"
          label={"Continue"}
          fullWidth={false}
          labelStyle={{ fontSize: 16 }}
          style={{ margin: 11 }}
          onClick={this.handleContinue}
          disabled={this.state.phone.length < 10}
        />
      </div>
    );
  }

  renderSlideFour() {
    return (
      <div
        style={{
          width: "55%",
          height: "85%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          margin: "auto",
          borderRadius: 10
        }}
      >
        <p style={{ color: "white", fontSize: 50, fontWeight: 300 }}>
          <b>Ok! Tell us what task you need completed</b>
        </p>
        <p
          style={{
            color: "white",
            fontSize: 30,
            fontWeight: 300,
            marginBottom: 30
          }}
        >
          Please keep it brief! We're gonna ask you for details on the next
          slide 😎
        </p>
        <br />
        <input
          value={this.state.title}
          type="text"
          style={{
            backgroundColor: "transparent",
            width: "50%",
            borderLeft: "none",
            borderRight: "none",
            borderTop: "none",
            borderBottom: "1px solid #ffffff",
            textAlign: "center",
            color: "#ffffff",
            fontSize: 30
          }}
             onChange={this.handleOnChange("title")}
        />
        <br />
        <br />
        <FlatButton
          backgroundColor="#90caf9"
          containerElement="label"
          label={"Continue"}
          fullWidth={false}
          labelStyle={{ fontSize: 16 }}
          style={{ margin: 11 }}
          onClick={this.handleContinue}
          disabled={this.state.title.length < 5}
        />
      </div>
    );
  }

  renderSlideFive() {
    const { email, password, phone, title, details } = this.state;
    return (
      <div
        style={{
          width: "55%",
          height: "85%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          margin: "auto",
          borderRadius: 10
        }}
      >
        <p style={{ color: "white", fontSize: 50, fontWeight: 300 }}>
          <b>Finally! Give us some details of the task if any.</b>
        </p>
        <p
          style={{
            color: "white",
            fontSize: 30,
            fontWeight: 300,
            marginBottom: 30
          }}
        >
          The more details upfront, the better we can serve you!
        </p>
        <br />
        <input
          value={this.state.details}
          type="text"
          style={{
            backgroundColor: "transparent",
            width: "50%",
            borderLeft: "none",
            borderRight: "none",
            borderTop: "none",
            borderBottom: "1px solid #ffffff",
            textAlign: "center",
            color: "#ffffff",
            fontSize: 15
          }}
               onChange={this.handleOnChange("details")}
        />
        <br />
        <br />
        <FlatButton
          backgroundColor="#90caf9"
          containerElement="label"
          label={"Let's get stuff done!"}
          fullWidth={false}
          labelStyle={{ fontSize: 16 }}
          style={{ margin: 11 }}
          onClick={() => this.props.signUpUser(email, password, phone, title, details, true)}
          disabled={this.state.details.length < 5 || this.state.creatingUser}
        />
      </div>
    );
  }

  renderSlideSix() {
    const { email, password, phone, title, details } = this.state;
    this.props.signUpUser(email, password, phone, title, details, true)
    return (
      <div
        style={{
          width: "55%",
          height: "85%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          margin: "auto",
          borderRadius: 10
        }}
      >
        <p style={{ color: "white", fontSize: 50, fontWeight: 300 }}>
          <b>We're good to go!</b>
        </p>
        <p
          style={{
            color: "white",
            fontSize: 30,
            fontWeight: 300,
            marginBottom: 30
          }}
        >
          Sit Tight...
        </p>
      </div>
    );
  }
}

const mapStateToProps = ({auth}) => {
    const { email, password, error, checked, loading }  = auth;
    return { email, password, error, checked, loading };
  };
export default connect(mapStateToProps,{ signUpUser })(Onboarding);
  



// WEBPACK FOOTER //
// ./src/components/onboarding/onboarding.js